import { useState } from "react";
import { Link, useSearchParams } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import Button from "../../components/ui/button/Button";
import Alert from "../../components/ui/alert/Alert";
import ChecklistSenha from "../../components/common/ChecklistSenha";
import CampoSenha from "../../components/common/CampoSenha";
import { useConfig } from "../../context/ConfigContext";
import { redefinirSenha } from "../../api/auth";
import { senhaForte } from "../../utils/forcaSenha";

export default function RedefinirSenha() {
  const { nomeApp } = useConfig();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [erro, setErro] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [concluido, setConcluido] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro("");
    if (!senhaForte(novaSenha)) {
      setErro("A senha não atende os requisitos mínimos abaixo.");
      return;
    }
    if (novaSenha !== confirmar) {
      setErro("As senhas não coincidem.");
      return;
    }
    setEnviando(true);
    try {
      await redefinirSenha(token, novaSenha);
      setConcluido(true);
    } catch (err: any) {
      setErro(err?.data?.erro || "Não foi possível redefinir a senha.");
    } finally {
      setEnviando(false);
    }
  };

  return (
    <>
      <PageMeta title={`Redefinir senha | ${nomeApp}`} description="Recuperação de senha" />
      <AuthLayout>
        <div className="flex flex-col flex-1">
          <div className="flex w-full max-w-md flex-1 flex-col justify-center mx-auto">
            <h1 className="mb-1.5 text-title-sm font-bold text-gray-850 dark:text-white/95">
              Escolha sua nova senha
            </h1>

            {!token ? (
              <Alert variant="error" title="Link inválido" message="Esse link de redefinição está incompleto. Peça um novo em 'Esqueci minha senha'." />
            ) : concluido ? (
              <>
                <Alert variant="success" title="Senha redefinida" message="Já pode entrar com a sua nova senha." />
                <p className="mt-6 text-center text-sm">
                  <Link to="/login" className="text-brand-500 hover:underline dark:text-brand-400">
                    Ir pro login
                  </Link>
                </p>
              </>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <CampoSenha label="Nova senha" value={novaSenha} onChange={setNovaSenha} />
                  <ChecklistSenha senha={novaSenha} />
                </div>
                <CampoSenha label="Confirmar nova senha" value={confirmar} onChange={setConfirmar} />
                {erro && <Alert variant="error" title="Erro" message={erro} />}
                <Button className="w-full" size="sm" disabled={enviando}>
                  {enviando ? "Salvando..." : "Redefinir senha"}
                </Button>
              </form>
            )}
          </div>
        </div>
      </AuthLayout>
    </>
  );
}
